import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { CognitoService } from '../cognito.service';
import { ManagedLoginService } from '../managed-login.service';


@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanLoad {
  authState: boolean = false;

  constructor(private authService: CognitoService, private router: Router) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService
      .isAuthenticated()
      .then((valor: boolean) => {
        this.authState = valor;

        if (this.authState) {
          return true;
        } else {
          this.router.navigate(['/auth']);
          return false;
        }
      })
      .catch(() => {
        this.router.navigate(['/auth']);
        return false;
      });
  }
}

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  authState: boolean = false;

  constructor(private router: Router, private authService: CognitoService) {}

/*   canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return this.authService
      .isAuthenticated()
      .then((valor: boolean) => {
        this.authState = valor;

        if (this.authState) {
          return true;
        } else {
          this.router.navigate(['/auth']);
          return false;
        }
      })
      .catch(() => {
        this.router.navigate(['/auth']);
        return false;
      });
  } */

  isAuthenticated(): boolean {
    const token = localStorage.getItem('access_token');
    return !!token;
  }

}

/* export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> => {
  return inject(PermissionsService).canActivate(next, state);
}; */

export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const authService = inject(PermissionsService);
  const managedLoginService=inject(ManagedLoginService)

  if (authService.isAuthenticated()) {
    return true;
  } else {
    managedLoginService.login()
    return false
  }
};